import React, { useState, useEffect } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { getTranslations } from "../Shared/translations";
import "./shared.css";
interface Klant {
  id: string;
  naam: string;
  voornaam: string;
  firma: string;
  straat: string;
  huisnummer: string;
  postcode: string;
  gemeente: string;
  land: string;
  telefoon: string;
  btw: string;
}

interface MyProps {
  onKlantUpdate: (klant: Klant) => any;
  klant: Klant;
}

const KlantForm: React.FC<MyProps> = ({ onKlantUpdate, klant }) => {
  const t = getTranslations();
  const [formData, setFormData] = useState<Klant>({
    id: "",
    naam: "",
    voornaam: "",
    firma: "",
    straat: "",
    huisnummer: "",
    postcode: "",
    gemeente: "",
    land: "",
    telefoon: "",
    btw: "",
  });

  // Initialize form with klant prop when it changes
useEffect(() => {
  setFormData(klant);
}, [klant]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const updatedKlant: Klant = {
      ...klant,
      ...formData,
    };

    // Clear form
    setFormData({
      id: "",
      naam: "",
      voornaam: "",
      firma: "",
      straat: "",
      huisnummer: "",
      postcode: "",
      gemeente: "",
      land: "",
      telefoon: "",
      btw: "",
    });

    onKlantUpdate(updatedKlant);
  };

  // Utility function to get current value (state OR fallback to props)
  const getValue = (key: keyof Klant) => formData[key] || klant[key];

  return (
    <Form onSubmit={handleSubmit} className="settings-form">
      <Form.Control type="hidden" value={getValue("id")} name="id" />

      <Row>
        <Col>
          <Form.Label className="form-label-primary">{t.naam}</Form.Label>
          <Form.Control
            type="text"
            value={getValue("naam")}
            name="naam"
            className="customer-form"
            onChange={handleChange}
          />
        </Col>

        <Col>
          <Form.Label className="form-label-primary">{t.voornaam}</Form.Label>
          <Form.Control
            type="text"
            value={getValue("voornaam")}
            name="voornaam"
            className="customer-form"
            onChange={handleChange}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={8}>
          <Form.Label className="form-label-primary">{t.firma}</Form.Label>
          <Form.Control
            type="text"
            value={getValue("firma")}
            name="firma"
            className="customer-form"
            onChange={handleChange}
          />
        </Col>
        <Col xs={4}>
          <Form.Label className="form-label-primary">{t.land}</Form.Label>
          <Form.Control
            type="text"
            value={getValue("land")}
            name="land"
            className="customer-form"
            onChange={handleChange}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <Form.Label className="form-label-primary">{t.straat}</Form.Label>
          <Form.Control
            type="text"
            value={getValue("straat")}
            name="straat"
            className="customer-form"
            onChange={handleChange}
          />
        </Col>
        <Col xs={3}>
          <Form.Label className="form-label-primary">{t.huisnummer}</Form.Label>
          <Form.Control
            type="text"
            value={getValue("huisnummer")}
            name="huisnummer"
            className="customer-form"
            onChange={handleChange}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={3}>
          <Form.Label className="form-label-primary">{t.postcode}</Form.Label>
          <Form.Control
            type="text"
            value={getValue("postcode")}
            name="postcode"
            className="customer-form"
            onChange={handleChange}
          />
        </Col>
        <Col>
          <Form.Label className="form-label-primary">{t.plaats}</Form.Label>
          <Form.Control
            type="text"
            value={getValue("gemeente")}
            name="gemeente"
            className="customer-form"
            onChange={handleChange}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <Form.Label className="form-label-primary">{t.telefoon}</Form.Label>
          <Form.Control
            type="text"
            value={getValue("telefoon")}
            name="telefoon"
            className="customer-form"
            onChange={handleChange}
          />
        </Col>
        <Col>
          <Form.Label className="form-label-primary">{t.btwnr}</Form.Label>
          <Form.Control
            type="text"
            value={getValue("btw")}
            name="btw"
            className="customer-form"
            onChange={handleChange}
          />
        </Col>
      </Row>

      <div className="settings-actions">
        <Button variant="primary" type="submit" className="btn-primary-app">
          {t.bewaar}
        </Button>
      </div>
    </Form>
  );
};

export default KlantForm;
